<div class="flex-wrapper">
  <div class="left-wrapper">
    <div class="logo">
      <img src="assets/images/logo.png">
    </div>

    <div class="logo-title">
      Molecular Contamination Control LifeTime Determination
    </div>
    
    <div class="logo-desc">
      Welcome to the Camfil's MCCLD Software.   
      <span class="footerDesc">
            <br>
            © Camfil 1963–2025 |
            <a href="https://www.camfil.com/en-my/privacy-policy" target="_blank" rel="noopener">
            Privacy policy and Cookie information
            </a>               
        </span>    
    </div>    

  </div>
  <div class="right-wrapper">
    <div class="login-head">
      <div class="logo">
        <img src="../../assets/images/logo.png">
      </div>
      <span>Login to your</span>
      <span>Camfil account</span>
    </div>
    <form class="loginForm" (ngSubmit)="login()" ngNativeValidate autocomplete="off">
      <div class="login-body">
        <div class="form-group">
          <span class="input-label">Email Address *</span>
          <input type="text" name="email" [(ngModel)]="email" class="input-btn" required>
        </div>
        <div class="form-group">
          <span class="input-label">Password * <span class="desc">at least 8 characters</span></span>
          <span><input name="password" type="password" [(ngModel)]="password" id="password" required class="input-btn typepassword">
            <span (click)="togglepassword()" class="eye">
              <fa-icon *ngIf="passwordflag" [icon]="faEye"></fa-icon>
              <fa-icon *ngIf="!passwordflag" [icon]="faEyeSlash"></fa-icon>
            </span>
          </span>
        </div>
      </div>
      <div class="login-button" *ngIf="!loading">
        <input type="submit" class="btn-login btn-primary btn ripple" value="Login">
    </div>
    <div class="login-button green" *ngIf="loading">
      <span class="spinner-border"  role="status" aria-hidden="true"></span>
      <span class="sr-only">Loading...</span>
    </div>
    </form>
  </div>
</div>
